import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import './styles.scss';

export default class CompanyFormSection extends PureComponent {
  static propTypes = {
    children: PropTypes.node.isRequired,
    counter: PropTypes.number.isRequired,
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
  };

  render() {
    const { id, children, title, counter } = this.props;

    return (
      <section className="company-form-section" id={id}>
        <header>
          <div className="company-form-section-bubble">{counter}</div>
          <h4 className="company-form-section__title">{title}</h4>
        </header>

        {children}
      </section>
    );
  }
}
